import React, { Component } from 'react';


import { Avatar, Button, Card, DataTable, DatePicker, DialogContainer,
    Grid, List, ListItem, SelectField, Subheader, TableBody, TableColumn, TableRow,
    TableHeader, TextField, Toolbar } from 'react-md';

import Api from '../../common/api';

import { formatPhone, firstChar, formatCurrency, formatCpf, formatCnpj, 
    formatCep } from '../../common/formaters';

import { clearDigitsSpecialChars } from '../../common/parsers';

import Message from '../../components/message';
import Breadcrumb from '../../components/Breadcrumb';
import Filter from '../../components/Filter';
import { openSnackbar } from '../../components/message';

const COLORS = Avatar.defaultProps.suffixes;
const TODAY = new Date();

export default class Clientes extends Component {

    constructor(props) {
        super(props);

        this.state = {
            compradores: [],
            visibleForm: false, 
            visiblePayments: false,
            pageX: null, 
            pageY: null,
            comprador: {
                id: "",
                nome: "",
                saldo_devedor: "",
                documento: "",
                telefones: [],
                endereco: {
                    rua: "",
                    numero: "",
                    complemento: "",
                    bairro: "",
                    cep: "",
                    id_estado: "",
                    id_cidade: ""
                }
            },
            estados: [],
            cidades: [],
            emptyComprador: {
                id: "",
                nome: "",
                saldo_devedor: "",
                telefones: [],
            },
            pagamento: {
                id: "",
                id_comprador: "",
                data: "",
                valor: ""
            },
            pagamentos: [],
            filter: ""
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.getAll();
        this.getAllEstados();
    }

    render() {
        const { pagamentos, pagamento, comprador, compradores, visibleForm, visiblePayments, 
            pageX, pageY, estados, cidades } = this.state;

        return (
            <Grid>
                <Breadcrumb title="Clientes" url="/clientes"/>
                <Card tableCard className="md-cell md-cell--12 tw-card">
                    <div className="buttons__group">
                        <div className="left-group">
                            <Button type="button" raised iconChildren="add" onClick={this.handleNewClick} 
                                aria-controls="modal-form" className="btn btn-info">
                                Novo
                            </Button>
                        </div>
                        <div className="right-group">
                            <Button type="button" raised primary iconChildren="payment" disabled={this.hasSelected()} 
                                aria-controls="modal-payments" onClick={this.handlePaymentCLick} className="btn btn-secondary">
                                Pagamentos
                            </Button>
                            <Button type="button" raised iconChildren="edit" onClick={this.handleEditCLick} 
                                disabled={this.hasSelected()} className="btn btn-warning"> 
                                Editar
                            </Button>
                        </div>
                    </div>
                    
                    <Filter onSearch={this.handleChangeFilter} placeholder="Pesquise por código, nome ou CPF"/>

                    <DataTable baseId="clientes-list" className="tw-table" plain={true} responsive>
                        <TableHeader>
                            <TableRow>
                                <TableColumn>Código</TableColumn>
                                <TableColumn>Cliente</TableColumn>
                                <TableColumn>CPF / CNPJ</TableColumn>
                                <TableColumn>Telefones</TableColumn>
                                <TableColumn className="column--currency">Saldo devedor</TableColumn>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                        { compradores.map((comprador, index) => (
                            <TableRow key={index} onClick={this.handleItemClick(comprador)} aria-controls="modal-form" 
                                className={this.renderSelectedClass(comprador)}>
                                <TableColumn>{comprador.id}</TableColumn>
                                <TableColumn className="column--avatar">
                                    <Avatar suffix={COLORS[index]}>{firstChar(comprador.nome)}</Avatar>
                                    { comprador.nome }
                                    { comprador.email }
                                </TableColumn>
                                <TableColumn>
                                    { comprador.documento && comprador.documento.length < 15 ? formatCpf(comprador.documento) : formatCnpj(comprador.documento) }
                                </TableColumn>
                                <TableColumn> 
                                    { comprador.telefones.map(telefone => formatPhone(telefone.numero)).join(' | ') }
                                </TableColumn>
                                <TableColumn className="column--currency">
                                    { formatCurrency(comprador.saldo_devedor) }
                                </TableColumn>
                            </TableRow>
                        ))}
                        </TableBody>
                    </DataTable>
                </Card>
                <div>
                    <DialogContainer id="modal-form" visible={visibleForm} pageX={pageX} pageY={pageY}
                        fullPage onHide={this.hideComprador} aria-labelledby="modal-form-title">
                        <form onSubmit={this.saveComprador}>
                        <Toolbar fixed colored title="Novo Cliente" titleId="modal-form-title" nav={<Button icon onClick={this.hideComprador}>close</Button>}
                            actions={<Button type="submit" raised className="btn btn-primary" iconChildren="check">Salvar</Button>} />
                        <section className="md-toolbar-relative">
                            <div className="md-cell--center md-cell--6">

                                <TextField id="nome" label="Nome" lineDirection="center" value={comprador.nome || ""}
                                    placeholder="Digite o nome do cliente" className="md-cell md-cell--12" 
                                    onChange={this.handleChangeComprador('nome')} required/>

                                <TextField id="documento" label="CPF / CNPJ" lineDirection="center" value={comprador.documento || ""}
                                    placeholder="Digite o CPF ou CNPJ do cliente" className="md-cell md-cell--12" 
                                    onChange={this.handleChangeDocumento('documento')}/>

                                <TextField id="saldo_devedor" label="Saldo devedor" lineDirection="center" value={comprador.saldo_devedor || ""}
                                    placeholder="Digite o saldo devedor do cliente" className="md-cell md-cell--12" 
                                    onChange={this.handleChangeCurrency('saldo_devedor')} required/>

                                {comprador.endereco ? 
                                    <div>
                                        <TextField id="endereco-cep" label="CEP" lineDirection="center" value={comprador.endereco.cep}
                                            placeholder="Digite o CEP do cliente" className="md-cell md-cell--12" 
                                            onChange={this.handleChangeCep} />
    
                                        <TextField id="endereco-rua" label="Rua" lineDirection="center" value={comprador.endereco.rua}
                                            placeholder="Digite o endereço do cliente" className="md-cell md-cell--12" 
                                            onChange={this.handleChangeEndereco('rua')} />
    
                                        <TextField id="endereco-numero" label="Número" lineDirection="center" value={comprador.endereco.numero}
                                            placeholder="Digite o número do cliente" className="md-cell md-cell--12" 
                                            onChange={this.handleChangeEndereco('numero')}/>
    
                                        <TextField id="endereco-complento" label="Complemento" lineDirection="center" value={comprador.endereco.complemento}
                                            placeholder="Digite o complemento do cliente" className="md-cell md-cell--12" 
                                            onChange={this.handleChangeEndereco('complemento')}/>
    
                                        <TextField id="endereco-bairro" label="Bairro" lineDirection="center" value={comprador.endereco.bairro}
                                            placeholder="Digite o bairro do cliente" className="md-cell md-cell--12" 
                                            onChange={this.handleChangeEndereco('bairro')} />
    
                                        <SelectField id="endereco-estado" placeholder="Selecione o Estado do cliente" className="md-cell md-cell--12 md-cell--bottom tw-select"
                                            menuItems={estados} position={SelectField.Positions.BELOW} simplifiedMenu={true} 
                                            value={comprador.endereco.id_estado || ""} onChange={this.handleChangeEstado} itemLabel="nome" itemValue="id" required/>
    
                                        <SelectField id="endereco-cidade" placeholder="Selecione a cidade do cliente" className="md-cell md-cell--12 md-cell--bottom tw-select"
                                            menuItems={cidades} position={SelectField.Positions.BELOW} simplifiedMenu={true} 
                                            value={comprador.endereco.id_cidade || ""} onChange={this.handleChangeEndereco('id_cidade')}
                                            itemLabel="nome" itemValue="id" required/>
                                    </div>
                                : null}
                                {comprador.telefones.map((telefone, index) => (
                                    <div key={index} className="inline-input">
                                        <TextField key={index} id={"telefone_" + index} label="Telefone" lineDirection="center" value={telefone.numero}
                                            placeholder="Digite o telefone com DDD" className="md-cell md-cell--12" 
                                            onChange={this.handleChangeTelefone(index)}/>
                                        {index === comprador.telefones.length - 1 && <Button icon onClick={this.addPhone}>add</Button>}
                                        
                                    </div>                                    
                                ))}
                                
                            </div>
                        </section>
                        </form>
                    </DialogContainer>
                </div>
                <div>
                    <DialogContainer id="modal-payments" visible={visiblePayments} pageX={pageX} pageY={pageY}
                        fullPage onHide={this.hidePagamento} aria-labelledby="modal-payments-title">
                        <Toolbar fixed colored title="Pagamentos" titleId="modal-payments-title" nav={<Button icon onClick={this.hidePagamento}>close</Button>}
                            actions={<Button type="button" raised className="btn btn-primary" iconChildren="check" onClick={this.savePagamento}>Salvar</Button>} />
                        <section className="md-toolbar-relative">
                            <div className="md-cell--center md-cell--6">

                                <DatePicker id="date-picker-auto-ok" label="Selecione a data"
                                    autoOk className="md-cell md-cell--12" defaultValue={TODAY}
                                    onChange={this.handleChangeData('data')} />

                                <TextField id="valor" label="Valor" lineDirection="center" value={pagamento.valor}
                                    placeholder="Digite o valor pago" className="md-cell md-cell--12" 
                                    onChange={this.handleChangeValor('valor')}/>

                                { pagamentos.length ? 
                                    <List className="md-cell md-cell--12 dividers__example md-paper md-paper--0 simple-list">
                                        <Subheader primaryText="Pagamentos realizados" />
                                        {pagamentos.map((pagamento, index) => (
                                            <ListItem key={index} primaryText={formatCurrency(pagamento.valor, 2)} secondaryText={pagamento.data} renderChildrenOutside>
                                                <Button icon primary onClick={this.onDeletePagamento(pagamento)}>delete</Button>
                                            </ListItem>
                                        ))}
                                    </List> : null
                                }
                            </div>
                        </section>
                    </DialogContainer>
                </div>
                <Message />
            </Grid>
        );
    }

    handleChange = name => value => {
        this.setState({ [name]: value });
    }

    handleItemClick = comprador => event => {
        comprador.saldo_devedor = formatCurrency(comprador.saldo_devedor);
        if(!comprador.endereco) comprador.endereco = {
            rua: "",
            numero: "",
            complemento: "",
            bairro: "",
            cep: "",
            id_estado: "",
            id_cidade: ""
        }
        setTimeout(() => this.setState({comprador}));
    }

    handleNewClick = () => {
        this.cleanComprador();
        this.addPhone();
        this.showComprador();
    }

    handleEditCLick = () => {
        this.selectEstadoAndCidadeBySigla(this.state.comprador.endereco.sigla);
        this.addPhone();
        this.showComprador();
    }

    renderSelectedClass = (comprador) => {
        return comprador.id === this.state.comprador.id ? "item-selected" : ""
    };

    hasSelected = () => this.state.comprador.id ? false : true;

    /** Pagamentos */

    handleChangeData = name => value => {
        let pagamento = this.state.pagamento;
        pagamento[name] = value;
        this.setState({ pagamento });
    }

    handleChangeValor = name => value => {
        let pagamento = this.state.pagamento;
        pagamento[name] = formatCurrency(value);
        this.setState({ pagamento });
    }

    handlePaymentCLick = () => {
        this.setCompradorOnPagamento();    
        this.getPagamentosComprador();
        this.showPagamento();
    }

    setCompradorOnPagamento = () => {
        let pagamento = this.state.pagamento;
        pagamento.id_comprador = this.state.comprador.id;
        this.setState({pagamento});
    }

    hidePagamento = () => {
        this.setState({ visiblePayments: false });
        this.cleanPagamento();
    }

    showPagamento = (e) => {
        if(e){
            let { pageX, pageY } = e;
            if (e.changedTouches) {
              pageX = e.changedTouches[0].pageX;
              pageY = e.changedTouches[0].pageY;
            }
            this.setState({ visiblePayments: true, pageX, pageY });
        } else {
            this.setState({ visiblePayments: true});
        }
    }

    getPagamentosComprador = () => {
        Api.getAllPagamentoByComprador(this.state.comprador.id)
        .then(response => response.json())
        .then(pagamentos => this.setState({pagamentos}))
        .catch(error => openSnackbar({ message: error }));
    }

    savePagamento = () => {
        let pagamento = this.state.pagamento;
        pagamento.valor = clearDigitsSpecialChars(pagamento.valor)
        Api.savePagamento(pagamento)
        .then(() => this.afterSavePagamento())
        .catch(error => openSnackbar({ message: error }));
    }

    cleanPagamento = () => {
        const pagamento = {
            id: "",
            id_comprador: "",
            valor: "",
            data: ""
        };
        this.setState({pagamento});
    }

    afterDeletePayment = () => {
        this.getPagamentosComprador();
    }

    afterSavePagamento = () => {
        openSnackbar({ message: 'Pagamento salvo com sucesso' });
        this.hidePagamento();
        this.handleChangeFilter(this.state.filter)
    }

    onDeletePagamento = pagamento => event => {
        Api.deletePagamento(pagamento)
        .then(() => this.afterDeletePayment())
        .catch(error => openSnackbar({ message: error }));
    }

    /** Comprador */

    handleChangeEndereco = name => value => {
        let comprador = this.state.comprador;
        comprador.endereco[name] = value;
        this.setState({ comprador });
    }

    handleChangeComprador = name => value => {
        let comprador = this.state.comprador;
        comprador[name] = value;
        this.setState({ comprador });
    }

    handleChangeCurrency = name => value => {
        let comprador = this.state.comprador;
        comprador[name] = formatCurrency(value);
        this.setState({ comprador });
    }

    handleChangeDocumento = name => value => {
        let comprador = this.state.comprador;
        if(value.length < 15)
            comprador[name] = formatCpf(value);
        if(value.length > 14)
            comprador[name] = formatCnpj(value);
        this.setState({ comprador });
    }

    handleChangeTelefone = index => value => {
        let comprador = this.state.comprador;
        comprador.telefones[index].numero = formatPhone(value);
        this.setState({ comprador });
    }

    hideComprador = () => {
        this.cleanComprador();
        this.setState({ visibleForm: false });
        this.handleChangeFilter(this.state.filter)
    }

    showComprador = (e) => {
        if(e){
            let { pageX, pageY } = e;
            if (e.changedTouches) {
              pageX = e.changedTouches[0].pageX;
              pageY = e.changedTouches[0].pageY;
            }
            this.setState({ visibleForm: true, pageX, pageY });
        } else {
            this.setState({ visibleForm: true});
        }
    }

    handleSearch = filter => {
        Api.getAllCompradores(filter)
        .then(response => response.json())
        .then(compradores => this.setState({compradores}))
        .catch(error => openSnackbar({ message: error }));
    }

    handleChangeFilter = filter => {
        this.handleSearch(filter);
        this.setState({ filter });
    }

    getAll = () => {
        Api.getAllCompradores()
        .then(response => response.json())
        .then(compradores => this.setState({compradores}))
        .catch(error => openSnackbar({ message: error }));
    }

    saveComprador = event => {
        event.preventDefault();
        let comprador = this.state.comprador;
        comprador.saldo_devedor = clearDigitsSpecialChars(comprador.saldo_devedor);
        comprador.documento = clearDigitsSpecialChars(comprador.documento);
        this.validatePhones();

        Api.saveComprador(this.state.comprador)
        .then(() => this.afterSaveComprador())
        .catch(error => openSnackbar({ message: error }));
    }

    addPhone = () => {
        let comprador = this.state.comprador;
        comprador.telefones.push({numero: ""});
        this.setState({comprador});
    }

    validatePhones = () => {
        let comprador = this.state.comprador;
        comprador.telefones = comprador.telefones.filter(telefone => telefone.numero) || null;
        this.setState({comprador});
    }

    isValidAddress = () => {
        let endereco = this.state.comprador.endereco;
        return endereco.rua && endereco.numero && endereco.bairro && endereco.cep && endereco.id_cidade;
    }

    afterDelete = () => {
        this.hideComprador();
        this.handleChangeFilter(this.state.filter)
    }

    afterSaveComprador = () => {
        openSnackbar({ message: 'Cliente salvo com sucesso' });
        this.hideComprador();
        this.handleChangeFilter(this.state.filter)
    }

    cleanComprador = () => {
        const comprador = {
            documento: null,
            email: null,
            endereco:{
                rua: "",
                numero: "", 
                complemento: "", 
                bairro: "", 
                cep: "",
            },
            id: "",
            nome: "",
            saldo_devedor: "",
            telefones: []
        };
        setTimeout(() => {
            this.setState({comprador: comprador});
        });
    }

    delete = () => {
        Api.deleteComprador(this.state.comprador)
        .then(() => this.afterDelete())
        .catch(error => openSnackbar({ message: error }));
    }

    /** Endereço */

    getAllEstados = event => {
        Api.getAllStates()
        .then(response => response.json())
        .then(estados => this.setState({estados}))
        .catch(error => openSnackbar({ message: error }));
    }

    handleChangeEstado = value => {
        let comprador = this.state.comprador;
        comprador.endereco.id_estado = value; 
        this.setState({comprador});
        Api.getCitiesByState(value)
        .then(response => response.json())
        .then(cidades => this.setState({cidades}))
        .catch(error => openSnackbar({ message: error }));
    }

    handleChangeCep = value => {
        let cep = formatCep(value)
        let comprador = this.state.comprador;
        comprador.endereco.cep = cep;
        this.setState({comprador});
        if(clearDigitsSpecialChars(cep).length === 8) {
            Api.getCep(clearDigitsSpecialChars(cep))
            .then(response => {
                switch (response.status) {
                    case 200:
                        response.json()
                            .then(data => {
                                comprador.endereco.rua = data.rua;
                                comprador.endereco.bairro = data.bairro;
                                this.selectEstadoAndCidadeBySigla(data.estado)
                                comprador.endereco.id_cidade = data.id_cidade;
                                this.setState({comprador});
                            })
                        break
                    default:
                        openSnackbar({ message: 'Não foi possível carregar o CEP.\nPor favor, informe manualmente.' });
                        break
                }
            }).catch(error => {
                openSnackbar({ message: 'Não foi possível carregar o CEP.\nPor favor, informe manualmente.' });
            });
        }
    };

    selectEstadoAndCidadeBySigla = sigla => {
        if(!sigla) return;
        let estado = this.state.estados.find(estado => estado.sigla === sigla)
        this.handleChangeEstado(estado.id);
    }

}



// WEBPACK FOOTER //
// ./src/views/clientes/Clientes.js